export const GET_OTHER_USER = 'GET_OTHER_USER';
